import { useState } from "react";
import { Link } from 'react-router-dom';

const CountryCard = ({ country }) => {
    const [flipped, setFlipped] = useState(false);

    return (
        <div
            className={`flip-card w-full ${flipped ? 'flipped' : ''}`}
            onClick={() => setFlipped(f => !f)}
        >
            <div className="flip-card-inner">
                {/* FRONT */}
                <div className="flip-card-front">
                    <img
                        src={country.banner}
                        className="w-full h-full object-cover"
                        alt={country.name}
                    />
                    {/* Gradient overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />

                    {/* Name */}
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                        <h5 className="font-unbounded font-bold text-xl text-white mb-2">
                            {country.name}
                        </h5>
                        <div className="flex items-center gap-2 text-white/60">
                            <span className="font-manrope text-xs">Tap to discover</span>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                        </div>
                    </div>

                    {/* Gold corner accent */}
                    <div className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-gold animate-pulse-slow" />
                    </div>
                </div>

                {/* BACK */}
                <div className="flip-card-back">
                    <div className="w-12 h-12 rounded-2xl bg-gold/15 border border-gold/30 flex items-center justify-center mb-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#CE2B37" strokeWidth="1.5">
                            <circle cx="12" cy="10" r="3"/>
                            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                        </svg>
                    </div>

                    <h5 className="font-unbounded font-bold text-lg text-gold">{country.name}</h5>

                    <p className="font-manrope text-white/70 text-sm leading-relaxed">
                        {country.description.length > 160
                            ? `${country.description.substring(0, 160)}...`
                            : country.description}
                    </p>

                    <Link
                        to={`/country/${country.id}`}
                        className="btn-gold mt-2"
                        onClick={e => e.stopPropagation()}
                    >
                        Explore tours
                    </Link>

                    <p className="font-manrope text-white/30 text-xs mt-2">Tap to flip</p>
                </div>
            </div>
        </div>
    );
};

export default CountryCard;
